<template>
  <div style="height: 100%;">
    <router-view />
    <el-backtop></el-backtop>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getAllCountries()
    },
    async getAllCountries () {
      const {data: result} = await this.$http.get('/mini/getAllCountries')
      if (result.code !== 200) return
      let countryList = [{
        label: '常用国家',
        options: [{
          value: 'CN',
          label: '中国'
        }, {
          value: 'AU',
          label: '澳大利亚'
        }, {
          value: 'ES',
          label: '西班牙'
        }, {
          value: 'GB',
          label: '英国'
        }, {
          value: 'JP',
          label: '日本'
        }, {
          value: 'KR',
          label: '韩国'
        }, {
          value: 'US',
          label: '美国'
        }]
      }, {
        label: '全部国家',
        options: []
      }]
      let filterCountryCode = countryList[0].options.map(item => item.value)
      result.data.forEach(item => {
        if (!filterCountryCode.includes(item.countryCode)) {
          countryList[1].options.push({
            label: item.nameCN,
            value: item.countryCode
          })
        }
      })
      this.$store.commit('setCountryList', countryList)
    }
  }
}
</script>

<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-button {
  display: none;
}

::-webkit-scrollbar-thumb {
  background: rgba(30, 80, 240, 0.3);
  cursor: pointer;
  border-radius: 4px;
}

::-webkit-scrollbar-corner {
  display: none;
}

::-webkit-resizer {
  display: none;
}

div, p, span {
  font-family: '苹方' !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue